import React from 'react';
import { IDashboardStats } from 'gen/ApiClient';
import { ICacheContext } from 'framework/context/ICacheContext';

export const CacheContext = React.createContext<ICacheContext<IDashboardStats>>(undefined as any);